// Administrateurs de la plateforme (frontend uniquement).
//
// Gère les comptes administratifs internes au Super Admin : identité, rôle,
// statut et dernière activité. Aucune donnée fictive : la collection démarre
// vide. La création reste possible (simulée côté frontend jusqu'à Supabase).
//
// Table future : `administrateurs` (id, prenom, nom, email, telephone, role,
// statut, notes, created_at, derniere_activite).

export type AdministrateurStatut = "actif" | "desactive";

export interface PlatformAdministrateur {
  id: string;
  prenom: string;
  nom: string;
  email: string;
  telephone: string;
  role: string;
  statut: AdministrateurStatut;
  notes: string;
  createdAt: string;
  derniereActivite: string;
}

export type PlatformAdministrateurInput = Omit<
  PlatformAdministrateur,
  "id" | "createdAt" | "derniereActivite"
>;

export const ADMINISTRATEUR_STATUT_LABELS: Record<AdministrateurStatut, string> = {
  actif: "Actif",
  desactive: "Désactivé",
};

export const ADMINISTRATEUR_STATUT_TONES: Record<AdministrateurStatut, "secondary" | "neutral"> = {
  actif: "secondary",
  desactive: "neutral",
};

export const ADMINISTRATEUR_STATUT_OPTIONS = (
  Object.keys(ADMINISTRATEUR_STATUT_LABELS) as AdministrateurStatut[]
).map((value) => ({ value, label: ADMINISTRATEUR_STATUT_LABELS[value] }));

export const ADMINISTRATEUR_ROLE_OPTIONS = [
  { value: "super_admin", label: "Super administrateur" },
];

export function administrateurRoleLabel(role: string): string {
  return ADMINISTRATEUR_ROLE_OPTIONS.find((option) => option.value === role)?.label ?? (role || "Rôle non défini");
}

export function administrateurNomComplet(admin: PlatformAdministrateur): string {
  return [admin.prenom, admin.nom].filter(Boolean).join(" ").trim() || "Administrateur";
}

export function administrateurInitiales(admin: PlatformAdministrateur): string {
  const prenom = admin.prenom.trim().charAt(0);
  const nom = admin.nom.trim().charAt(0);
  return `${prenom}${nom}`.toUpperCase() || "AD";
}